import gql from 'graphql-tag'

export const orderType = gql`
	fragment orderType on OrderType {
		id
        mod_ver
        code
        reportKind
        isActive
        name
        cashRegisterId
        type
        firstDate
        dateSpan
        reportCount
        statisticDate1
        flag
        orderTypeStandartised
        statisticDate2
        isMon
        isTue
        isWed
        isThu
        isFri
        isSat
        isSun
        storageRelationId
        rawCreditClientId
        showAllButton
		isTemplateMode
	}
`
